import React from 'react';

const DescriptionComponent = ({ text }) => {
  if (!text) return null;

  return (
    <div className="large:rf-min-w-1/2 large:rf-pl-4 rf-flex rf-flex-col rf-items-center">
      <div className="rf-w-full rf-flex rf-flex-col rf-items-start">
        <div className="large-vertical:rf-max-h-[30vh] rf-font-medium rf-overflow-y-scroll rf-pb-4 rf-pr-4 rf-scroll-pb-4 rf-scrollbar-hidden">
          {text}
        </div>
      </div>
    </div>
  );
};

export default DescriptionComponent;
